<template>
    <div class="wrap">
        <Headers :title="title" />
        <div class="main">
            <video src="../../../assets/plateInfo.mp4" class="main-img" controls></video>
            <!-- <img src="../../../assets/main-info-mb.png" alt="" class="main-img"> -->
            <div class="item" v-if="language == 'zh'">
                <div class="item-name">全球数字贸易云展会平台</div>
                <div class="item-info">全球数字贸易云展会平台（简称”浙展汇“），是浙江数字服务贸易云展会平台（2020国务院“深化服务贸易创新发展试点第二批最佳实践案例”）的迭代升级，是全球数字贸易博览会的线上先行。 平台展陈和运营取“1+N”生态联动：展区呈现为1个共享展区，N个行业展馆；运营方为1个主体运营，N个展会主办方自主运营，联动全球优质展会主办方资源，实现全球可孪生数字办展，服务企业双线参展，打造展览展示、撮合预约洽谈、会议、培训等功能，建设全球展会数字化生态平台。</div>
            </div>
            <div class="item" v-else>
                <div class="item-name">Global Digital Trade Cloud Exhibition Platform</div>
                <div class="item-info-en">The global digital trade cloud exhibition platform is an iterative upgrade of the Zhejiang digital service trade cloud exhibition platform (the second batch of best practice cases in the “Deepening Service Trade Innovation and Development Pilot Program” of the State Council in 2020), and is the online leader of the global digital trade expo. Platform exhibition and operation follow the "1+N" ecological linkage: the exhibition area is presented as a shared exhibition area, N industry pavilions; the operator is a main body operation, N exhibition organizers independently operate, linking with global high-quality exhibition organizers Resources, realize the global twin-digital exhibition, serve the dual-line exhibition of enterprises, create functions such as exhibition display, matchmaking appointment negotiation, conference, training, etc., and build a digital ecological platform for global exhibitions.</div>
            </div>
        </div>
        <div class="detail" v-if="language == 'zh'">
            <div class="detail-item" v-for="(item, index) in cnlist" :key="index" >
                <img :src="item.src" alt="" class="img">
                <div class="list-content">
                    <div class="name">{{ item.name }}</div>
                    <div class="info">{{ item.info }}</div>
                </div>
            </div>
        </div>
         <div class="detail" v-else>
            <div class="detail-item" v-for="(item, index) in enlist" :key="index" >
                <div class="background-img">
                    <img src="../../../../static/blank_img.png" class="blank_img" alt="">
                    <img :src="item.src" alt="" class="img-en">
                </div>
               <div class="list-content">
                    <div class="name">{{ item.name }}</div>
                    <div class="info-en">{{ item.info }}</div>
                </div>
            </div>
        </div>
        <Footers />
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
import Footers from "../mobileExhibition/components/Footers";
import { isMobile } from "../../../utils/encrypt";
import { mapState } from "vuex";
export default {
    components: {
        Headers,
        Footers
    },
    data() {
        return {
            hideMenu: false,
            type: null,
            cnlist:[
                {
                    src: require('../../../assets/info-template1.png'),
                    name: '云展览',
                    info: '线上展厅：全方位展示公司产品、技术实力、企业文化等；3D产品环物：360°多维度展示产品细节、外观结构等',
                },
                {
                    src: require('../../../assets/info-template2.png'),
                    name: '云洽谈',
                    info: '在线洽谈：可实现文字、图片、表情等富媒体消息收发；随时沟通：与感兴趣的展商实时沟通，提高用户转化率',
                },
                {
                    src: require('../../../assets/info-template3.png'),
                    name: '云直播',
                    info: '提供直播服务，实现展会开幕式直播，展商直播，线上发布会等多种直播形式，帮助客户全面展示企业形象和公司产品',
                },
                {
                    src: require('../../../assets/info-template4.png'),
                    name: '云会议',
                    info: '采用全球可互通的音视频通话技术，在平台上即可实现网上“面对面”沟通， 全面满足商家与买家的实时洽谈需求，随时谈生意',
                }
            ],
            enlist:[
                {
                    src: require('../../../assets/info-template1-en.png'),
                    name: 'Cloud Exhibition',
                    info: 'Online exhibition hall: comprehensive display of company products, technical strength, corporate culture, etc.; 3D product circle: 360° multi-dimensional display of product details, appearance structure, etc.',
                },
                {
                    src: require('../../../assets/info-template2-en.png'),
                    name: 'Cloud Negotiation',
                    info: 'Online negotiation: can realize the sending and receiving of rich media messages such as text, pictures, and emoticons; communicate at any time: communicate with interested exhibitors in real time to improve user conversion rate',
                },
                {
                    src: require('../../../assets/info-template3-en.png'),
                    name: 'Cloud Live',
                    info: 'Provide live broadcast services, realize live broadcast of the opening ceremony of the exhibition, live broadcast of exhibitors, online press conferences, etc., to help customers fully display the corporate image and company products',
                },
                {
                    src: require('../../../assets/info-template4-en.png'),
                    name: 'Cloud Conference',
                    info: 'Using global interoperable audio and video call technology, online "face-to-face" communication can be realized on the platform, fully satisfying the real-time negotiation needs of merchants and buyers, and discussing business at any time',
                }
            ]
        }
    },
    mounted(){
        // this.type = isMobile()
        // console.log(language)
    },
    computed: {
        title(){
            return this.language == 'zh' ? '全球数字贸易云展会平台简介' : 'Introduction to Global Digital Trade Cloud Exhibition Platform'
        },
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        ...mapState(["userInfo","language"]),
    },
    methods:{
        
    }
}
</script>

<style lang="scss" scoped>
.main{
    width: 100%;
    // height: 10.22rem;
    background-color: #fff;
    border-top: 1px solid rgba(25,75,150,0.15);
    display: flex;
    flex-direction: column;
    // padding: 40px 120px ;
    .main-img{
        width: 100%;
        height: 4.22rem;  
    }
    .item{
        // margin-left: 24px;
        padding: .32rem;
        .item-name{
            font-size: 18px;
            font-weight: 500;
            text-align: left;
            color: #333333;
            line-height: .52rem;
            margin-bottom: .16rem;
        }
        .item-info{
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #666666;
            line-height: .52rem;
        }
        .item-info-en{
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #666666;
            line-height: .52rem;
            word-wrap: break-word;
            white-space: normal;
            // text-align:justify;
            word-break: keep-all;
        }
    }
}
.detail{
    padding: .28rem .32rem 1.86rem;
    display: flex;
    flex-direction: column;
    .detail-item{
        // margin-right: 24px;
        display: flex;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: .32rem;
        &:last-child{
            margin-bottom: unset;
        }
        .background-img{
            width: 3.2rem;
            height: 4rem;
            position: relative;
            .blank_img{
                width: 3.2rem;
                height: 4rem;
            }
            .img-en{
                position: absolute;
                width: 2.8rem;
                height: 2.4rem;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                margin: auto;
            }
        }
        .img{
            width: 3.2rem;
            height: 2.4rem;
        }
        .list-content{
            display: flex;
            flex-direction: column;
            margin-left: .24rem;
            .name{
                font-size: 14px;
                font-weight: 500;
                text-align: left;
                color: #333333;
                line-height: .44rem;
                margin-bottom: .08rem;
            }
            .info{
                // width: 2.42rem;
                text-align: left;
                font-size: 12px;
                font-weight: 400;
                color: #666666;
                line-height: .4rem;
                // word-wrap: break-word;
                // white-space: normal;
                // // text-align:justify;
                // word-break: keep-all;
            }
            .info-en{
                text-align: left;
                font-size: 12px;
                font-weight: 400;
                color: #666666;
                line-height: .4rem;
                word-wrap: break-word;
                white-space: normal;
                // text-align:justify;
                word-break: keep-all;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileplateformInfo/index.vue